import { render, staticRenderFns } from "./UserReferal.vue?vue&type=template&id=2b679df3&scoped=true&"
import script from "./UserReferal.vue?vue&type=script&lang=js&"
export * from "./UserReferal.vue?vue&type=script&lang=js&"
import style0 from "./UserReferal.vue?vue&type=style&index=0&id=2b679df3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b679df3",
  null
  
)

export default component.exports